module.exports = __webpack_public_path__ + "img/b66aa87.jpg";